/**
 * Модуль именован с суффиксом .config и расширением tsx из-за ограничений платформы. SonarQube не пропускает дублирование ключей в объекте.
 * @see https://gitlab.rshbdev.ru/rshbintech/support-board/-/issues/18844
 **/

export const translations = {
  ru_RU: {
    TOOLTIP_TEXT: "Операция недоступна из-за ограничений",
    OWN_FARMING_MENU_ITEM_TEXT: "Своё Фермерство",
    CREATE_BUTTON: "Создать",
    OWN_FARMING_DIALOG_DICTIONARY: {
      HEADER_TEXT:
        "Платформа новых возможностей для развития вашего агробизнеса",
      CONTENT_TEXT:
        "Покупка и продажа товаров на крупнейшем аграрном маркетплейсе, услуги для агробизнеса, меры поддержки АПК, цифровые сервисы и не только",
      PROCEED_BUTTON_TEXT: "Перейти",
    },
    ITEMS: {
      TOP: {
        ACCOUNTS_AND_PAYMENTS: "Счета и платежи",
        ACCREDITIVS: "Аккредитивы",
        INVOICES: "Счета на оплату",
        STATEMENT: "Выписка",
        TEMPLATES: "Шаблоны",
        ANALYTICS: "Аналитика",
        COUNTERPARTIES: "Контрагенты",
        SWIFT_MESSAGES: "SWIFT сообщения",
        TARIFFS: "Тарифы",
        CERTIFICATES: "Справки",
        APPLICATIONS: "Заявки",
        WRITE_OFF_SERVICES: "Реестры по ном. счетам",
        TRUSTEES_REPORTS: "Отчёты попечителей",
      },
      MIDDLE: {
        SALARY_PROJECT: "Зарплатный проект",
        BUSINESS_CARDS: "Бизнес-карты",
        DEPOSITS: "Депозиты",
        ACQUIRING: "Эквайринг",
        BROKERAGE_SERVICES: "Брокерское обслуживание",
        FOREIGN_ECONOMIC_ACTIVITY: "ВЭД",
        LOANS: "Кредиты",
        ALL_SERVICES: "Все сервисы",
        LOYALTY_PROGRAM: "Программа лояльности",
        SIMPLIFIED_TAXATION_SYSTEM: "АУСН",
        NSD_CERTIFICATE: "Сертификат НРД",
      },
      SAAS: {
        PRODUCTS_AND_SERVICES: "Товары и услуги",
        WEBSITE_BUILDER: "Конструктор сайтов",
        DEALS: "Сделки",
      },
      BOTTOM: {
        MAIL: "Письма",
        HELP: "Помощь",
        SETTINGS: "Настройки",
      },
    },
  },
  en: {
    TOOLTIP_TEXT: "Operation not available due to restrictions",
    OWN_FARMING_MENU_ITEM_TEXT: "Own Farming",
    CREATE_BUTTON: "Create",
    OWN_FARMING_DIALOG_DICTIONARY: {
      HEADER_TEXT:
        "A platform of new opportunities for developing your agribusiness",
      CONTENT_TEXT:
        "Buying and selling goods on the largest agricultural marketplace, services for agribusiness, measures to support the agro-industrial complex, digital services and more",
      PROCEED_BUTTON_TEXT: "Proceed",
    },
    ITEMS: {
      TOP: {
        ACCOUNTS_AND_PAYMENTS: "Accounts and payments",
        ACCREDITIVS: "Letters of credit",
        INVOICES: "Invoices",
        STATEMENT: "Statement",
        TEMPLATES: "Templates",
        ANALYTICS: "Analytics",
        COUNTERPARTIES: "Counterparties",
        SWIFT_MESSAGES: "SWIFT messages",
        TARIFFS: "Tariffs",
        CERTIFICATES: "Certificates",
        APPLICATIONS: "Applications",
        WRITE_OFF_SERVICES: "Registers for nominal",
        TRUSTEES_REPORTS: "Trustees reports",
      },
      MIDDLE: {
        SALARY_PROJECT: "Salary project",
        BUSINESS_CARDS: "Business cards",
        DEPOSITS: "Deposits",
        ACQUIRING: "Acquiring",
        BROKERAGE_SERVICES: "Brokerage services",
        FOREIGN_ECONOMIC_ACTIVITY: "FEA",
        LOANS: "Loans",
        ALL_SERVICES: "All services",
        LOYALTY_PROGRAM: "Loyalty program",
        SIMPLIFIED_TAXATION_SYSTEM: "STS",
        NSD_CERTIFICATE: "NSD certificate",
      },
      SAAS: {
        PRODUCTS_AND_SERVICES: "Products and services",
        WEBSITE_BUILDER: "Website builder",
        DEALS: "Deals",
      },
      BOTTOM: {
        MAIL: "Mail",
        HELP: "Help",
        SETTINGS: "Settings",
      },
    },
  },
} as const;
